import React from 'react';
import { _MenuButton } from './styled-sidebar';

const MenuButton = ({
  text,
  icon,
  selected,
  onClick
}) => (
  <_MenuButton onClick={onClick} selected={selected}>
    {icon}
    {text}
  </_MenuButton>
)

export default MenuButton;


// WEBPACK FOOTER //
// ./src/components/menu/menu-button.js